import { Avatar, Box, Paper, Typography, styled } from '@mui/material';

export const CardContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive, theme }) => ({
  padding: '0.75rem',
  border: isActive ? `1px solid ${theme.palette.accent.main}` : '1px solid transparent',
  borderRadius: '0.75rem',
  backgroundColor: '#F5F5F7',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  fontFamily: 'Neue Frutiger World',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#EBEBEE',
    borderColor: isActive ? theme.palette.accent.main : 'transparent',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
  },
}));

export const FileThumbnail = styled('img', {
  shouldForwardProp: (prop) => prop !== 'isPlaceholder',
})<{ isPlaceholder: boolean }>(({ isPlaceholder }) => ({
  width: '40px',
  height: '56px',
  borderRadius: '4px',
  objectFit: 'cover',
  backgroundColor: '#f0f0f0',
  opacity: isPlaceholder ? 0.7 : 1,
}));

export const FileThumbnailPlaceholder = styled(Box)({
  width: '40px',
  height: '56px',
  borderRadius: '4px',
  backgroundColor: '#E5E7EB',
  flexShrink: 0,
});

export const FileNameText = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#615E6F',
  lineHeight: 1.3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const UploaderBadge = styled(Avatar)(({ theme }) => ({
  width: 20,
  height: 20,
  fontSize: '0.65rem',
  backgroundColor: theme.palette.accent.main,
  color: 'white',
}));

export const DetailsContainer = styled(Box)({
  marginTop: '1rem',
  paddingTop: '1rem',
  borderTop: '1px solid #F3F4F6',
  display: 'grid',
  gridTemplateColumns: '1fr 2fr',
  rowGap: '0.5rem',
  fontSize: '0.75rem',
});

export const LabelText = styled(Typography)({
  color: '#9CA3AF',
  fontSize: '0.8rem',
});

export const ValueText = styled(Typography)({
  color: '#615E6F',
  fontSize: '0.8rem',
});
